import { Flex, Icon, isNullish, OverflowText } from "@theorgchartdev/storybook";
import { getFieldIcon } from "@/appComponents/Blocks/Cards/RecordInfoCard/utils";
import React from "react";
import { ChangesPendingText } from "@/appComponents/Blocks/Composites/ChangesPendingText/ChangesPendingText";

export const RecordFieldRow = ({ fVPair, delta }) => {
  const { field, value, fieldName, fieldDef } = fVPair;
  const staticTextStyle = {
    minHeight: "15px"
  };

  const unsavedChanges = !isNullish(delta[fieldName]);
  return (
    <Flex gap={"8px"} alignItems={"center"}>
      <Icon name={getFieldIcon(fieldDef)} size={"xsmall"} modifier={"control"} />
      <OverflowText
        size="xsmall"
        colorModifier={unsavedChanges ? "warning" : "grey"}
        style={staticTextStyle}
        modifier={unsavedChanges ? "medium" : "default"}
      >
        {field}
      </OverflowText>
      {unsavedChanges && <ChangesPendingText priorValue={value} newValue={delta[fieldName]} />}
    </Flex>
  );
};
